<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title">The Eustace Diamonds</p>
<p class="ORIM-Chapter-Subtitle">A Palliser Novel</p>
<p class="ORIM-Author-Name">Anthony Trollope</p>
<p class="ORIM-Author-Name"><img alt="logo" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Eustace_Diamonds-1.vue?de72e9fc